import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["placeholder", "mask", "label"],
    _excluded2 = ["placeholder", "mask", "label"];
import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import { FieldInput, FieldRoot, useField } from "../internal/Field";
import { getMethodsForTestId } from "../utils/getMethodsForTestId";
import { isArray, isString } from "../utils/type";
import { themes } from '../Textfield';
import styles from './RangeField.css';
var cx = classNames.bind(styles);
var INITIAL_VALUE = ['', ''];

var parseValue = function parseValue(value) {
  if (isString(value)) {
    return value.split(' - ');
  }

  if (isArray(value)) {
    return value;
  }

  return INITIAL_VALUE;
};

var RangeField = function RangeField(_ref) {
  var className = _ref.className,
      _ref$leftProps = _ref.leftProps,
      leftProps = _ref$leftProps === void 0 ? defaultPropObject : _ref$leftProps,
      _ref$rightProps = _ref.rightProps,
      rightProps = _ref$rightProps === void 0 ? defaultPropObject : _ref$rightProps,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      style = _ref.style,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'b2c' : _ref$theme,
      value = _ref.value,
      invalid = _ref.invalid,
      namespace = _ref.namespace;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      leftValue = _useState2[0],
      setLeftValue = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      rightValue = _useState4[0],
      setRightValue = _useState4[1];

  var _useField = useField({
    onFocus: onFocus,
    onBlur: onBlur
  }),
      handleBlur = _useField.handleBlur,
      handleFocus = _useField.handleFocus,
      focused = _useField.focused;

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'rangeField'),
      getNamespace = _getMethodsForTestId.getNamespace;

  useEffect(function () {
    if (value) {
      var _parseValue = parseValue(value),
          _parseValue2 = _slicedToArray(_parseValue, 2),
          left = _parseValue2[0],
          right = _parseValue2[1];

      setLeftValue(left);
      setRightValue(right);
    }
  }, [value]);

  var handleChangeLeft = function handleChangeLeft(e) {
    setLeftValue(e.target.value);

    if (onChange) {
      onChange([e.target.value, rightValue]);
    }
  };

  var handleChangeRight = function handleChangeRight(e) {
    setRightValue(e.target.value);

    if (onChange) {
      onChange([leftValue, e.target.value]);
    }
  };

  var placeholderLeft = leftProps.placeholder,
      maskLeft = leftProps.mask,
      labelLeft = leftProps.label,
      restLeft = _objectWithoutProperties(leftProps, _excluded);

  var placeholderRight = rightProps.placeholder,
      maskRight = rightProps.mask,
      labelRight = rightProps.label,
      restRight = _objectWithoutProperties(rightProps, _excluded2);

  return /*#__PURE__*/React.createElement(FieldRoot, _extends({
    size: "small",
    theme: theme,
    focused: focused,
    invalid: invalid,
    classes: {
      root: className,
      container: cx('container')
    },
    namespace: getNamespace()
  }, style), /*#__PURE__*/React.createElement(FieldInput, _extends({
    placeholder: placeholderLeft,
    onChange: handleChangeLeft,
    onBlur: handleBlur,
    onFocus: handleFocus,
    mask: maskLeft,
    value: leftValue,
    theme: theme,
    invalid: invalid,
    classes: {
      inner: cx('inner')
    },
    namespace: getNamespace('startDate')
  }, restLeft)), /*#__PURE__*/React.createElement("div", {
    className: cx('dash')
  }, "\u2013"), /*#__PURE__*/React.createElement(FieldInput, _extends({
    placeholder: placeholderRight,
    onChange: handleChangeRight,
    onBlur: handleBlur,
    onFocus: handleFocus,
    mask: maskRight,
    value: rightValue,
    theme: theme,
    invalid: invalid,
    classes: {
      inner: cx('inner')
    },
    namespace: getNamespace('endDate')
  }, restRight)));
};

export { themes };
export default RangeField;